export const HEADING_TEXT = 'View Our Open Roles';
export const SUBHEADING_TEXT = "We're looking for great people to join our growing team";
export const PAGE_TITLE = 'Careers';
export const META_DESCRIPTION = "We're looking for great people to join our growing team";
export const FONT_WEIGHT_OPTIONS = [
  { label: 'Light - 200', value: '200' },
  { label: 'Normal - 400', value: '400' },
  { label: 'Semi bold - 600', value: '600' },
  { label: 'Bold - 700', value: '700' },
];

export const FONT_FAMILY_OPTIONS = [
  { label: 'Default (Recommended)', value: 'inherit' },
  { label: 'Arial (sans-serif)', value: 'Arial, sans-serif' },
  { label: 'Verdana (sans-serif)', value: 'Verdana, sans-serif' },
  { label: 'Helvetica (sans-serif)', value: 'Helvetica, sans-serif' },
  { label: 'Tahoma (sans-serif)', value: 'Tahoma, sans-serif' },
  { label: 'Trebuchet MS (sans-serif)', value: "'Trebuchet MS', sans-serif" },
  { label: 'Times New Roman (serif)', value: "'Times New Roman', serif" },
  { label: 'Georgia (serif)', value: 'Georgia, serif' },
  { label: 'Garamond (serif)', value: 'Garamond, serif' },
  { label: 'Courier New (monospace)', value: "'Courier New', monospace" },
  { label: 'Brush Script MT (cursive)', value: "'Brush Script MT', cursive" },
  { label: 'Roboto (sans-serif)', value: "'Roboto', sans-serif" },
  { label: 'Lato (sans-serif)', value: "'Lato', sans-serif" },
  { label: 'Montserrat (sans-serif)', value: "'Montserrat', sans-serif" },
  { label: 'Merriweather Sans (sans-serif)', value: "'Merriweather Sans', sans-serif" },
];

export const FONT_CASING_OPTIONS = [
  { label: 'Uppercase (default)', value: 'uppercase' },
  { label: 'Normal', value: 'none' },
  { label: 'Lowercase', value: 'lowercase' },
  { label: 'Capitalize', value: 'capitalize' },
];

export const CONTENT_ALIGNMENT_OPTIONS = [
  { label: 'Center (default)', value: 'center' },
  { label: 'Left', value: 'left' },
];

export const INDUSTRY_OPTIONS = [
  { label: 'Select ...', value: '' },
  'Automotive',
  'Beauty',
  'Baby Care Products',
  'Consumer Electronics',
  'Digital Goods',
  'Fashion & Apparel',
  'Food & Beverage',
  'Home Goods, Furnitures & Appliances',
  'Health, Wellness & Fitness',
  'Jewelry',
  'Restaurants',
  'Toys',
  'Other',
];

export const EMPLOYEE_SIZE = [{ label: 'Select ...', value: '' }, '1 - 10', '11 - 25', '26 - 50', '51 - 250', '250+'];
